/**
 * Brand Constants
 * Centralized branding text for the application.
 * Use these constants instead of hardcoding the brand name.
 */

export const BRAND = {
  /** The official brand name - no space, PascalCase */
  NAME: 'LucidDock',

  /** Tagline displayed on landing page and marketing materials */
  TAGLINE: "Your family's essentials, anchored & secure.",

  /** Full brand tagline with name */
  FULL_TAGLINE: "LucidDock — Your family's essentials, anchored & secure.",

  /** Copyright text */
  COPYRIGHT: `© ${new Date().getFullYear()} LucidDock. All rights reserved.`,

  /** Team signature for emails/messages */
  TEAM_SIGNATURE: 'LucidDock Team',
} as const;
